import {useCallback} from 'react';
import {useReportStore} from '../../useReportStore';

/**
 * Custom hook for reading editor content from various sources
 *
 * @param {object} rteRef - Reference to the RTE editor
 * @returns {function} Function to get current editor content
 */
export function useEditorContent(rteRef) {
    const editorView = useReportStore(state => state.editorView);

    const getEditorContent = useCallback(() => {
        try {
            if (editorView?.state?.doc) {
                return editorView.state.doc.toJSON();
            }

            if (rteRef) {
                const candidate = rteRef.current || rteRef;
                if (candidate && typeof candidate.getJSON === 'function') {
                    return candidate.getJSON();
                }
            }
        } catch (err) {
            console.error('Error reading editor content', err);
        }

        return null;
    }, [editorView, rteRef]);

    return {getEditorContent};
}
